/*
 * @Description:  在正式环境输出控制台信息
 * @Author: erickuang
 * @Date: 2021-01-25 10:56:08
 * @LastEditor: erickuang
 * @LastEditTime: 2021-12-24 15:06:36
 */

type ColorType = 'error' | 'success' | 'warn' | 'info' | 'disabled' | 'log';

// 颜色映射
const LABEL_BG = '#5C5C5C';
const typeColorMap: { [key in ColorType]: string } = {
  error: '#BE634E',
  success: '#83C432',
  warn: '#A1BE2A',
  info: '#4E7CBB',
  disabled: '#9D9D9D',
  log: '#9D9D9D',
};

/**
 * 获得相应的输出函数
 *
 * @param {String} type 输出类型: error/success/warn/info/disabled/log
 * @returns
 */
function getConsoleFunction(type: ColorType, prefixDefault?: string) {
  return function (content = '', prefix = prefixDefault) {
    console.info(
      `%c${prefix}%c${content}`,
      `padding: 4px 6px;background-color: ${LABEL_BG};border-radius: 5px 0 0 5px;color: #fff`,
      `padding: 4px 6px;background-color: ${typeColorMap[type]};border-radius: 0 5px 5px 0;color: #fff`,
    );
  };
}

/**
 * 获得ProConsole对象
 *
 * @returns {Object} ProConsole对象
 */
export function getProConsole(prefixDefault = 'V') {
  if ((window as any).proConsole) return (window as any).proConsole;
  const proConsole: { [key in ColorType]: Function } = {} as { [key in ColorType]: Function };
  Object.keys(typeColorMap).forEach((v) => {
    proConsole[v as ColorType] = getConsoleFunction(v as ColorType, prefixDefault);
  });
  return proConsole;
}

/**
 * 初始化ProConsole对象，将其挂载到window上
 */
function initProConsole(prefixDefault = 'V') {
  /* istanbul ignore else */
  if (!(window as any).proConsole) (window as any).proConsole = getProConsole(prefixDefault);
}

export { initProConsole };
